<template>
  <div class="notificationsPanel" :class="expanded" v-click-outside="hidePanel">
    <div class="notificationsPanel__header">
      <div class="notificationsPanel__title">
        {{ $t('messeger.notification') }}
      </div>
      <div class="notificationsPanel__close" @click="hidePanel"><img src="static/img/close-blue.svg"/></div>
    </div>
    <div class="notificationsPanel__list">
      <ui-scrollbar @onScroll="onScroll">
        <notifications-list></notifications-list>
      </ui-scrollbar>
    </div>
  </div>
</template>

<script>
  import NotificationsList from './List';

  export default {
    name: 'notificationsPanel',
    components: {NotificationsList},
    methods: {
      hidePanel () {
        this.$store.commit('notifications/toggleExpanded', false)
      },
      async onScroll (event) {
        let scrollContainer = event.target
        if (scrollContainer && !this.loading && scrollContainer.scrollHeight - scrollContainer.clientHeight - scrollContainer.scrollTop < 1000) {
          this.loading = true
          try {
            await this.$store.dispatch('notifications/loadNotifications', {append: true})
          } catch (e) {
            console.log('[notifications lazy load]', e)
          }
          this.loading = false
        }
      }
    },
    computed: {
      expanded () {
        return this.$store.state.notifications.panelExpanded ? 'expanded' : ''
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .notificationsPanel {
    background: #ffffff;
    position: absolute;
    right: -350px;
    width: 350px;
    height: 100%;
    z-index: 100;
    transition: right ease 0.3s, visibility .3s;
    visibility: hidden;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    @media (max-width: $screen-md) {
      display: none;
    }
    &.expanded {
      right: 0;
      visibility: visible;
    }
    &__header {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: $topbat-height;
      line-height: $topbat-height;

    }
    &__title {
      font-size: 16px;
      font-weight: 700;
      color: #000000;
    }
    &__close {
      cursor: pointer;
    }
    &__list {
      flex: 1;
      overflow: auto;
      position: relative;
      .notifications-list {
        padding: 0 20px;
      }
      .simplebar-track.vertical, .simplebar-vertical {
        right: auto;
        left: 0;
      }
    }
  }
</style>